<div class="flex-1 flex flex-col gap-6">
  <div class="relative rounded-3xl overflow-hidden bg-grey-900 aspect-[4/3] flex items-center justify-center">
    <video #video class="w-full h-full object-cover" [class.hidden]="viewState() !== 'streaming'" autoplay muted playsinline></video>
    <canvas #canvas class="hidden"></canvas>

    @if (viewState() === 'requesting') {
      <p class="text-white text-sm px-6 text-center">Solicitando acceso a la cámara...</p>
    }

    @if (viewState() === 'denied' || viewState() === 'error') {
      <div class="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-grey-900 px-6 text-center">
        <activar-icon name="alert_warning" size="3rem" />
        @if (viewState() === 'denied') {
          <p class="text-white text-sm">
            Necesitamos acceso a la cámara para verificar tu vehículo. Activá el permiso desde la configuración del
            navegador y reintentá.
          </p>
        } @else {
          <p class="text-white text-sm">
            No pudimos acceder a la cámara. Verificá que tu navegador la soporte y que estés en una conexión segura
            (HTTPS).
          </p>
        }
        <button
          type="button"
          class="py-2 px-6 rounded-2xl font-semibold text-sm bg-white text-grey-900 hover:bg-grey-100 transition-colors"
          (click)="retry()"
        >
          Reintentar
        </button>
      </div>
    }

    @if (tip(); as tipText) {
      @if (viewState() === 'streaming') {
        <div class="absolute bottom-0 left-0 right-0 px-4 py-3 bg-black/40 flex items-center gap-2">
          <div class="w-2 h-2 rounded-full bg-warning-400 flex-shrink-0"></div>
          <span class="text-white text-xs">{{ tipText }}</span>
        </div>
      }
    }
  </div>

  @if (viewState() === 'streaming') {
    <button
      type="button"
      class="w-full py-4 rounded-2xl font-semibold text-base bg-primary-600 text-white flex items-center justify-center gap-2 hover:bg-grey-800 transition-colors mt-auto"
      (click)="capture()"
    >
      <activar-icon name="image" size="1.25rem" class="text-white" />
      Capturar foto
    </button>
  }
</div>
